<!--Dashboard and side menu-->
<template>
 <v-navigation-drawer
  expand-on-hover
  color="#1c2b36"
  dark
  class="pb-10"
  mobile-breakpoint="1260"
  width="210"
  app
  :value="drawerStatus"
  @input="drawerStatusChange"
 >
  <v-list dense class="px-0 mx-0 pt-4">
   <v-list-item class="font-weight-light pa-2 pb-4">
    <v-img contain height="45px" :src="require('@/assets/AquaopDesktop.png')" @click="goToLandingPage()"></v-img>
   </v-list-item>

   <v-list-item to="/accountSetting" active-class="active-button" class="px-2 pr-5 py-0 pt-2 pb-2" :disabled="!isActive">
    <v-avatar class="ml-1" color="indigo" size="30">
     <span class="white--text subtext"
      >{{ $store.getters.getUserInfo.first_name.slice(0, 1) }}{{ $store.getters.getUserInfo.last_name.slice(0, 1) }}</span
     >
    </v-avatar>

    <v-list-item-title class="pl-6 font-weight-regular grey--text text--lighten-2"
     >{{ $store.getters.getUserInfo.first_name }} {{ $store.getters.getUserInfo.last_name }}</v-list-item-title
    >
   </v-list-item>
  </v-list>
  <v-divider class="" />

  <v-list expand dense class="px-0 mx-0 pa-0 pt-2">
   <v-list-group class="px-0 mx-0">
    <v-icon slot="prependIcon">mdi-chart-gantt</v-icon>
    <template v-slot:activator class="px-0">
     <v-list-item-content>
      <v-list-item-title class="font-weight-regular grey--text text--lighten-2">RMM </v-list-item-title>
     </v-list-item-content>
    </template>
    <template v-for="(subPage, i) in rmmSubPages">
     <v-list-item :key="i" @click="goToPage(subPage)">
      <v-list-item-content class="pl-6">
       <v-list-item-title class="font-weight-regular grey--text text--lighten-2 pl-2">{{ subPage.name }} </v-list-item-title>
      </v-list-item-content>
     </v-list-item>
    </template>
   </v-list-group>

   <v-list-group class="px-0 mx-0">
    <v-icon slot="prependIcon">mdi-calculator</v-icon>
    <template v-slot:activator class="px-0">
     <v-list-item-content>
      <v-list-item-title class="font-weight-regular grey--text text--lighten-2">
       FFT
       <span class="side-menu-tag">New</span>
      </v-list-item-title>
     </v-list-item-content>
    </template>
    <template v-for="(subPage, i) in fftv2SubPages">
     <v-list-item :key="i" @click="goToPage(subPage)">
      <v-list-item-content class="pl-6">
       <v-list-item-title class="font-weight-regular grey--text text--lighten-2 pl-2">{{ subPage.name }} </v-list-item-title>
      </v-list-item-content>
     </v-list-item>
    </template>
   </v-list-group>

   <v-list-group class="px-0 mx-0">
    <v-icon slot="prependIcon">mdi-graph</v-icon>
    <template v-slot:activator class="px-0">
     <v-list-item-content>
      <v-list-item-title class="font-weight-regular grey--text text--lighten-2">FFT Legacy</v-list-item-title>
     </v-list-item-content>
    </template>
    <template v-for="(subPage, i) in fftSubPages">
     <v-list-item :key="i" @click="goToPage(subPage)">
      <v-list-item-content class="pl-6">
       <v-list-item-title class="font-weight-regular grey--text text--lighten-2 pl-2">{{ subPage.name }} </v-list-item-title>
      </v-list-item-content>
     </v-list-item>
    </template>
   </v-list-group>

   <v-list-group class="px-0 mx-0">
    <v-icon slot="prependIcon">mdi-home-flood</v-icon>
    <template v-slot:activator class="px-0">
     <v-list-item-content>
      <v-list-item-title class="font-weight-regular grey--text text--lighten-2">EVT </v-list-item-title>
     </v-list-item-content>
    </template>
    <template v-for="(subPage, i) in evtSubPages">
     <v-list-item :key="i" @click="goToPage(subPage)">
      <v-list-item-content class="pl-6">
       <v-list-item-title class="font-weight-regular grey--text text--lighten-2 pl-2">{{ subPage.name }} </v-list-item-title>
      </v-list-item-content>
     </v-list-item>
    </template>
   </v-list-group>
   <template v-for="(item, index) in items">
    <!-- Checks role of user to determine what they have access to in the menu-->
    <v-list-item
     active-class="active-button"
     :key="index"
     :to="item.link"
     class="mx-0 pr-2 pl-4"
     v-if="$store.getters.getUserInfo.role_level >= item.role"
    >
     <v-list-item-action class="mx-0 mr-6">
      <v-icon>{{ item.icon }}</v-icon>
     </v-list-item-action>
     <v-list-item-content>
      <v-list-item-title class="subheader font-weight-regular text--lighten-2">{{ item.text }}</v-list-item-title>
     </v-list-item-content>
    </v-list-item>
   </template>
  </v-list>
  <v-footer absolute color="#1c2b36" class="text-overline">
   <v-spacer></v-spacer>
   <div class="text-truncate">{{ $store.getters.getVersionNumber }}</div>
  </v-footer>
 </v-navigation-drawer>
</template>

<script>
export default {
 props: ["drawerStatus"],
 async mounted() {},
 methods: {
  drawerStatusChange(value) {
   this.$emit("drawerStatusChange", value);
  },
  goToPage(site) {
   this.$router.push({ path: site.route }).catch(err => {});
  },
  goToLandingPage() {
   this.$router.push({ path: "/homePage" }).catch(err => {});
  },
 },
 data() {
  return {
   isActive: false,
   rmm: {
    prependIcon: "mdi-sitemap",
    icon: "mdi-chevron-up",
    "icon-alt": "mdi-chevron-down",
    text: "RMM",
    isDisableable: true,
    model: false,
    role: 0,
   },
   rmmSubPages: [
    {
     name: "Ingredient List",
     route: "/ingredientList",
    },
    {
     name: "Suppliers",
     route: "/supplierList",
    },
   ],
   fftSubPages: [
    {
     name: "New Formulation",
     route: "/fft/formulation/speciesList",
    },
    {
     name: "Formulation Archive",
     route: "/fft/newFormulationArchive",
    },
    {
     name: "Price Sensitivity Archive",
     route: "/fft/priceSensitivityArchive",
    },
   ],
   fftv2SubPages: [
    {
     name: "Formulation Tool",
     route: "/FormulationTool",
    },
    {
     name: "Formulation List",
     route: "/FormulationList",
    },
    // {
    //  name: "Archived Formulation",
    //  route: "/ArchivedFormulations",
    // },
    {
     name: "Formulation Reports",
     route: "/fftReports",
    },
    {
     name: "Ingredient List",
     route: "/recipeList",
    },
    {
     name: "Nutr. Spec List",
     route: "/nutritionalSpecs",
    },
    {
     name: "Prod Volume Estimate",
     route: "/fft/pve/countrySelection",
    },
   ],
   evtSubPages: [
    {
     name: "Latest Valuation",
     route: "/evtValuation",
    },
    {
     name: "New Simulation",
     route: "/evtSimulation",
    },
    {
     name: "Simulation Archives",
     route: "/evtHistoricalSimulations",
    },
   ],
   items: [
    {
     icon: "mdi-currency-usd",
     text: "Ingredient Prices",
     link: "/ingredientPrices",
     active: this.isActive,
     isDisableable: true,
     role: 0,
    },
    {
     icon: "mdi-cogs",
     text: "Management",
     link: "/management",
     active: this.isActive,
     isDisableable: true,
     role: 0,
    },
    // {
    //  icon: "mdi-note-multiple-outline",
    //  text: "Release Notes",
    //  link: "/releaseNotes",
    //  active: this.isActive,
    //  isDisableable: true,
    //  role: 0,
    // },
    // {
    //  icon: "mdi-face-agent",
    //  text: "Support",
    //  link: "/support",
    //  active: this.isActive,
    //  isDisableable: true,
    //  role: 0,
    // },
    {
     icon: "mdi-alarm-light",
     text: "Admin",
     link: "/admin",
     active: this.isActive,
     isDisableable: true,
     role: 4,
    },

    {
     icon: "mdi-logout",
     text: "logout",
     link: "/",
     isDisableable: false,
     role: 0,
    },
   ],
  };
 },
};
</script>

<style>
.v-list-group__header__prepend-icon {
 margin-right: 18px !important;
}
.v-list-item--active {
 color: #1976d2 !important;
}

.side-menu-tag {
 background-color: #ffeb3b;
 color: black;
 padding: 2px 6px;
 border-radius: 8px;
 font-size: 0.75em;
 margin-left: 7px;
}
</style>
